import { render, staticRenderFns } from "./EventoListaOrganizador.vue?vue&type=template&id=0aa175f5&"
import script from "./EventoListaOrganizador.vue?vue&type=script&lang=js&"
export * from "./EventoListaOrganizador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports